import { render, staticRenderFns } from "./AddSelector.vue?vue&type=template&id=557d2e7c&"
import script from "./AddSelector.vue?vue&type=script&lang=ts&"
export * from "./AddSelector.vue?vue&type=script&lang=ts&"
import style0 from "./AddSelector.vue?vue&type=style&index=0&id=557d2e7c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports